import { z } from 'zod';

/** Rôles applicatifs (`auth.md`). Le plugin admin de Better Auth nomme `member` son rôle par défaut. */
export const UserRole = z.enum(['admin', 'member']);
export type UserRole = z.infer<typeof UserRole>;

export const PublicUser = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  role: UserRole,
});
export type PublicUser = z.infer<typeof PublicUser>;

export const BudgetSettings = z.object({
  monthlyCapUsd: z.number(),
  scanCapUsd: z.number(),
  warnRatio: z.number(),
});
export type BudgetSettings = z.infer<typeof BudgetSettings>;

/** `GET /me`. */
export const MeResponse = z.object({
  user: PublicUser,
  settings: z.object({ budget: BudgetSettings }),
});
export type MeResponse = z.infer<typeof MeResponse>;
